import React from 'react';
import kosarevPhoto from '../assets/images/kosarev-vsevolod.jpg';
import {Link} from "react-router-dom";
import {LINKS} from "../constants/links";

function Home() {
    return (
        <div className="clearfix home-page">
            <img
                src={kosarevPhoto}
                className="col-6 col-md-4 float-start me-3 mb-2"
                style={{width: '180px', height: 'auto', borderRadius: '10px'}}
                alt="Kosarev Vsevolod"
            />
            <h1 className="h2">みんなさん、こんにちは！</h1>
            <p>Hi there, I'm Seva. This is my personal website where I share my projects.</p>
            <p>My current project is <Link to={LINKS.LEARNING_CARDS_SERVICE} className="text-decoration-none"  >a flashcard
                app</Link> designed to help with memorization. I'm building it to support my learning of the Japanese
                language 🌸</p>
        </div>
    );
}

export default Home;
